module.exports = __webpack_public_path__ + "static/media/LogoLarge.ea67afd0.svg";